import axios from 'axios';
import queryString from "query-string";


export const sendData = (message, type) =>
{
  var url = queryString.stringifyUrl({
    url: process.env.REACT_APP_ANALYTICAPI_URL + "/log",
    query: {
      message,
      type,
      userId:localStorage.getItem('userId')
    }
  });

  axios.get(url).catch(function (error) {
   
  });
}

export const formatDecimal = (num) =>
{
  if(Number.isInteger(num))
    return num;
  else
    return (Math.round(num * 100) / 100).toFixed(2);
}

// Copies text to the clipboard with a graceful degradation path.
// `navigator.clipboard` is only defined in secure contexts (HTTPS,
// localhost) — e.g. when testing the PWA via LAN HTTP on a real phone it's
// undefined, and a bare `.writeText` call throws. Tries the modern API
// first, falls back to a hidden textarea + `document.execCommand('copy')`
// for the non-secure path.
export const copyToClipboard = async (text) => {
  if (!text) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // fall through to legacy path
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    textarea.setAttribute('readonly', '');
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (e) {
    return false;
  }
};

// Truncate `text` at a word boundary so the result is at most ~maxLength chars
// (suffix included, if any). Used for compact card titles where verbose
// retailer product names would otherwise blow past the visual budget even
// with CSS line-clamping. Default suffix is empty — call sites that want an
// ellipsis or other indicator must pass it explicitly. Returns the original
// string if it already fits.
export const truncateAtWord = (text, maxLength = 95, suffix = '') => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  const budget = Math.max(1, maxLength - suffix.length);
  const sliced = text.slice(0, budget);
  const lastSpace = sliced.lastIndexOf(' ');
  const cutoff = lastSpace > 10 ? lastSpace : budget;
  return sliced.slice(0, cutoff).replace(/[\s\-–—:,;.]+$/u, '') + suffix;
};